import { SelectionType } from 'app/shared/selection/SelectionType';

interface Attributes {
    positions: Cesium.Cartesian3[];
    color: Cesium.Color;
    width: number;
    id: string | number;
    snapping?: boolean;
}

export function generateGroundPolylinePrimitiveOptions({
    positions,
    color,
    width,
    id,
    snapping = true,
}: Attributes): Partial<Cesium.GroundPolylinePrimitive> {
    const lineGeometry = new Cesium.GroundPolylineGeometry({
        positions,
        width,
        loop: false,
    });

    const geometryInstance = new Cesium.GeometryInstance({
        geometry: lineGeometry,
        attributes: {
            color: Cesium.ColorGeometryInstanceAttribute.fromColor(color),
        },
        id: {
            getId: () => id,
            id,
            selectionType: SelectionType.ENTITY,
            snapping,
        },
    });

    return {
        releaseGeometryInstances: false,
        geometryInstances: geometryInstance,
        appearance: new Cesium.PolylineMaterialAppearance({
            material: Cesium.Material.fromType('Color', {
                color,
            }),
        }),
        asynchronous: false,
    };
}
